import { render, staticRenderFns } from "./salesGoodsItem.vue?vue&type=template&id=467fa57e&scoped=true"
import script from "./salesGoodsItem.vue?vue&type=script&lang=js"
export * from "./salesGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./salesGoodsItem.vue?vue&type=style&index=0&id=467fa57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467fa57e",
  null
  
)

export default component.exports